import { render, staticRenderFns } from "./OtpremnicaList.vue?vue&type=template&id=6e604fde&scoped=true&"
import script from "./OtpremnicaList.vue?vue&type=script&lang=js&"
export * from "./OtpremnicaList.vue?vue&type=script&lang=js&"
import style0 from "./OtpremnicaList.vue?vue&type=style&index=0&id=6e604fde&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e604fde",
  null
  
)

export default component.exports